/** Teinte d’accent Chat — même palette 12 couleurs que Mail. */

export const CHAT_ACCENT_STORAGE_KEY = "chat_accent";

export const CHAT_ACCENT_IDS = [
  "red",
  "orange",
  "yellow",
  "green",
  "blue",
  "purple",
  "pink",
  "slate",
  "teal",
  "indigo",
  "fuchsia",
  "lime",
] as const;

export type ChatAccentId = (typeof CHAT_ACCENT_IDS)[number];

export type ChatAccentPreset = {
  id: ChatAccentId;
  label: string;
  swatch: string;
  accent: string;
  accentRgb: string;
  accentStrong: string;
};

export const CHAT_ACCENT_PRESETS: Record<ChatAccentId, ChatAccentPreset> = {
  red: {
    id: "red",
    label: "Rouge",
    swatch: "#dc2626",
    accent: "#dc2626",
    accentRgb: "220 38 38",
    accentStrong: "#b91c1c",
  },
  orange: {
    id: "orange",
    label: "Orange",
    swatch: "#ea580c",
    accent: "#ea580c",
    accentRgb: "234 88 12",
    accentStrong: "#c2410c",
  },
  yellow: {
    id: "yellow",
    label: "Jaune",
    swatch: "#ca8a04",
    accent: "#ca8a04",
    accentRgb: "202 138 4",
    accentStrong: "#a16207",
  },
  green: {
    id: "green",
    label: "Vert",
    swatch: "#16a34a",
    accent: "#16a34a",
    accentRgb: "22 163 74",
    accentStrong: "#15803d",
  },
  blue: {
    id: "blue",
    label: "Bleu Aurélia",
    swatch: "#71baff",
    accent: "#71baff",
    accentRgb: "113 186 255",
    accentStrong: "#2b7fd4",
  },
  purple: {
    id: "purple",
    label: "Violet",
    swatch: "#7c3aed",
    accent: "#7c3aed",
    accentRgb: "124 58 237",
    accentStrong: "#6d28d9",
  },
  pink: {
    id: "pink",
    label: "Rose",
    swatch: "#db2777",
    accent: "#db2777",
    accentRgb: "219 39 119",
    accentStrong: "#be185d",
  },
  slate: {
    id: "slate",
    label: "Gris foncé",
    swatch: "#475569",
    accent: "#475569",
    accentRgb: "71 85 105",
    accentStrong: "#334155",
  },
  teal: {
    id: "teal",
    label: "Turquoise",
    swatch: "#0d9488",
    accent: "#0d9488",
    accentRgb: "13 148 136",
    accentStrong: "#0f766e",
  },
  indigo: {
    id: "indigo",
    label: "Indigo",
    swatch: "#4f46e5",
    accent: "#4f46e5",
    accentRgb: "79 70 229",
    accentStrong: "#4338ca",
  },
  fuchsia: {
    id: "fuchsia",
    label: "Fuchsia",
    swatch: "#c026d3",
    accent: "#c026d3",
    accentRgb: "192 38 211",
    accentStrong: "#a21caf",
  },
  lime: {
    id: "lime",
    label: "Citron vert",
    swatch: "#84cc16",
    accent: "#84cc16",
    accentRgb: "132 204 22",
    accentStrong: "#65a30d",
  },
};

const CHAT_ACCENT_ID_SET = new Set<string>(CHAT_ACCENT_IDS);

export function normalizeChatAccentId(value: string | null | undefined): ChatAccentId {
  if (value === "violet") return "purple";
  if (value && CHAT_ACCENT_ID_SET.has(value)) return value as ChatAccentId;
  return "blue";
}

export function chatAccentPreset(accentId: ChatAccentId | string | null | undefined): ChatAccentPreset {
  return CHAT_ACCENT_PRESETS[normalizeChatAccentId(accentId ?? undefined)];
}

export function readChatAccent(): ChatAccentId {
  try {
    return normalizeChatAccentId(localStorage.getItem(CHAT_ACCENT_STORAGE_KEY));
  } catch {
    return "blue";
  }
}

export function persistChatAccent(accentId: ChatAccentId): void {
  try {
    localStorage.setItem(CHAT_ACCENT_STORAGE_KEY, normalizeChatAccentId(accentId));
  } catch {
    /* ignore */
  }
}
